













































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import { ISearchInvoicesRequest, InvoiceStatus, IStaff, ICustomer } from "@/interfaces";
import StatusFilter from "./status-filter.vue";
import {
  RimRepairAutocompleteComponent
} from "@/components/common";
import { GetCustomer, SearchCustomers } from '@/api';
import { HELPER } from "@/utils/Helper";
import TechSelect from '../../common/tech-select.vue'

// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";

@Component({
  components: { StatusFilter, RimRepairAutocompleteComponent, TechSelect },
})
export default class InvoiceSearchFilters extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
  mounted() {
		this.Techs = this.$store.getters["AppModule/staff"]
		.sort((a:IStaff, b:IStaff)=>{
			return a.Initials.localeCompare(b.Initials);
		});

		this.Req.InvoiceStatus = [InvoiceStatus.ReadyToPost];
		this.Req.PageSize = 5;

		this.sortItems.push(
			{text: 'Default', value: ''},
			{text: 'Date Asc', value: 'CreatedOn ASC'}, 
			{text: 'Date Desc', value: 'CreatedOn DESC'},
			);
  }
  // created(){}

  /* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop()
	public value: ISearchInvoicesRequest;
	
  @Prop({default: false})
	public Layout2: boolean;

  @Prop({default: true})
	public showTechnicianDropdown: boolean;

  /* PRIVATE VARIABLES, __ POSTFIXED */
  // private myVar__: any;

  /* VUE DATA */
  public Req: ISearchInvoicesRequest = new ISearchInvoicesRequest();
	public Techs: IStaff[] = [];

  public popup1: boolean = false;
  public popup2: boolean = false;

	public sortItems: any[] = [];


  /* VUE WATCH */
  @Watch("value", { immediate: true })
  onValueChanged(newVal: any, oldVal: any) {
    this.Req = newVal;

		if (newVal!=null && newVal.CustomerID != undefined){
				console.log("customer search required", this.Req.CustomerID);
				// this.searchCustomerFn(newVal.CustomerID)
		}
  }

  /* VUE COMPUTED METHODS */
  // get date(): Date {
  //   return new Date();
  // }

  /* PRIVATE METHODS */
  // private MyFunction():void{}

	/* VUE METHODS */
	public GetTechName(s:IStaff): string{
 		var rval = `[${s.Initials}] ${s.FName} ${s.LName}`;
		return rval;
	}

  private to__: number = 0;
  public KeywordUpdated(): void {
    clearTimeout(this.to__);

    this.to__ = setTimeout(() => {
      this.FiltersUpdated();
    }, 500);
  }

  public ClearMax(): void {
    this.Req.MaxDate = null;
    this.FiltersUpdated();
		(this.$refs.maxfield as any).blur();
  }

  public ClearMin(): void {
    this.Req.MinDate = null;
		this.FiltersUpdated();
		(this.$refs.minfield as any).blur();
  }

  // public ClearTech(): void {
  //   this.Req.TechID = null;
	// 	this.FiltersUpdated();
	// 	(this.$refs.techsel as any).blur();
  // }


  public FiltersUpdated(): void {
    clearTimeout(this.to__);

    this.$emit("input", this.Req);
    this.$emit("change", this.Req);
	}

	



  async searchCustomerFn(value: string | number): Promise<ICustomer[]> {
    if (typeof value === "number") {
      const resp = await GetCustomer(value);
      return resp.Ok ? [resp.Customer] : [];
    } else {
      const resp = await SearchCustomers(value, 0, 5);
      return resp.Ok ? resp.Results.Customers : [];
    }
  }

  public updateCustomer(customer: ICustomer) {
		this.Req.CustomerID= customer.RecordID;
		console.log('receiving', customer);
		this.FiltersUpdated();
  }

}
